<template>
    <div class="player-control-panel__info-description">
        <div ref="main"  class="player-control-panel__info-description-inner">
            <div ref="inner">
                {{ props.text }}
            </div>
        </div>
        <div v-if="isVisibleBtns" class="player-control-panel__info-description-btns">
            <button 
                :id="props.infoUpBtn.id"
                class="player-control-panel__info-description-btn" 
                :data-keydown="props.infoUpBtn.dataKeydown" 
                :data-keyright="props.infoUpBtn.dataKeyright"
                :data-type="props.infoUpBtn.dataType"
                @click="onUp"
                @keydown.up="hideControls"
                @blur="onUnfocus"
                @focus="onFocus"
            >
                <player-icon :icon-name="props.infoUpBtn.iconAttrs?.iconName" />
            </button>
            <button 
                :id="props.infoDownBtn.id"
                class="player-control-panel__info-description-btn" 
                :data-keydown="props.infoDownBtn.dataKeydown" 
                :data-keyright="props.infoDownBtn.dataKeyright"
                :data-keyup="props.infoDownBtn.dataKeyup"
                @click="onDown"
                @blur="onUnfocus"
                @focus="onFocus"
            >
                <player-icon :icon-name="props.infoDownBtn.iconAttrs?.iconName" />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        text: {
            type: String,
            required: true
        },
        infoUpBtn: {
            type: Object,
            required: true
        },
        infoDownBtn: {
            type: Object,
            required: true
        }
    });

    const emit = defineEmits([
        'hide-controls',
        'close-player'
    ]);

    const {  $navigator } = useNuxtApp();
    const main = ref<HTMLDivElement | null>(null);
    const inner = ref<HTMLDivElement | null>(null);
    let step = 0;
    const isVisibleBtns = ref(false);
    const init = (): void => {
        const mainHeight = main.value?.clientHeight ?? 0;
        const innerHeight = inner.value?.scrollHeight ?? 0;
        step = Math.ceil(mainHeight / 2);

        if (innerHeight > mainHeight) {
            isVisibleBtns.value = true;
        } else {
            isVisibleBtns.value = false;
        }
    };  

    const onUp = (): void => {
        main.value?.scrollBy({ top: -step, behavior: 'smooth' });
    };
    const onDown = (): void => {
        main.value?.scrollBy({ top: step, behavior: 'smooth' });
    };
    const hideControls = (event: KeyboardEvent | HTMLElement | null): void => {
        emit('hide-controls', event);
    };

    const closePlayer = (): void => {
        emit("close-player");
    };

    const onUnfocus = (): void => {
        $navigator.off("keypress:back", closePlayer);
    };
    const onFocus = (): void => {
        $navigator.on("keypress:back", closePlayer);
        
    };
    onMounted((): void => {
        void nextTick((): void => {
            init();
        });
    });
</script>